//НАПИСАТЬ УНИВЕРСАЛЬНУЮ ПРОГРЕССИВНУЮ ЗАГРУЗКУ
import * as THREE from 'three';
import * as Camera from './Camera.js';
import { loader, getRootHref } from './loader.js';
import { sceneLoadPromise } from './porevit.js';
import { materials } from './materials.js';
import { DebugEnvironment } from 'three/examples/jsm/Addons.js';
import { servObj } from './init_glob.js';
import gsap from 'gsap';
import { hideLoaderElement, showLoaderElement } from './loaderElement.js';

export const sceneHandler = {
    init: init,
};

let scene;
export let dayHDRI, nightHDRI;

loader.loadTextures(
    `${getRootHref()}/environment`,
    ['kloofendal_48d_partly_cloudy_puresky_1k.hdr'],
    async (textures) => {
        await sceneLoadPromise;
        scene.environment = textures[0];
        dayHDRI = textures[0];
        // scene.background = textures[0];
        // scene.backgroundIntensity = 3;
        // scene.backgroundBlurriness = 1;

        scene.environmentIntensity = 0.5;
        scene.environmentRotation.y = -0.2;

        const envFolder = gui.addFolder('Environment');
        envFolder.add(scene, 'environment', textures);
        envFolder.add(scene, 'environmentIntensity', 0, 10);
        envFolder.addVector(scene.environmentRotation, 'environmentRotation');
    }
);

loader.loadTextures(`${getRootHref()}/environment`, ['moonlit_golf_1k.hdr'], async (textures) => {
    nightHDRI = textures[0];
});

function init(incomingScene) {
    scene = incomingScene;
    scene.background = new THREE.Color(0xffffff);

    setUpCameraFromImported('camera', 'camera_target');
    setupFPVCamera();
    setupOrthoCamera();

    createLighting();

    materials.getMaterial('glass').depthWrite = false;
    materials.getMaterial('glass').side = THREE.FrontSide;
    materials.getMaterial('bathhouse_glass').depthWrite = false;
    materials.getMaterial('bathhouse_glass').side = THREE.FrontSide;
    materials.getMaterial('glass_light_pole').depthWrite = false;
    materials.getMaterial('glass_light_pole').side = THREE.FrontSide;
    materials.getMaterial('jeep_glass').depthWrite = false;
    materials.getMaterial('jeep_glass').side = THREE.FrontSide;

    materials.getMaterial('wood').aoMapIntensity = 0.3;
    materials.getMaterial('wood_ao_fake').aoMapIntensity = 0.3;
    materials.getMaterial('wood_dark').aoMapIntensity = 0.3;

    materials.getMaterial('tiles').roughness = 1.4;
    materials.getMaterial('tiles').normalScale.x = 2;
    materials.getMaterial('tiles').normalScale.y = 2;

    scene.getObjectByName("fence_brick_instanced").visible = false
    scene.getObjectByName("fence_brick").visible = false

    setQualityHandler();

    gui.addMaterial(materials.getMaterial('wood'));

    scene.getObjectByName('point_lights').visible = false;

    // gui.loadFromLocalStorage();

    let nightMode = false;
    document.querySelector('#day-night').addEventListener('pointerdown', () => {
        showLoaderElement(false, true);
        setTimeout(() => {
            nightMode = !nightMode;
            setNightMode(nightMode);
            servObj.nightMode = nightMode;
            servObj.isChangingMode = true;

            if (nightMode) {
                document.querySelector('#day-night').classList.add('active');
            } else {
                document.querySelector('#day-night').classList.remove('active');
            }
        }, 0);
    });
    servObj.autorotate = false;
    document.querySelector('#autorotate').addEventListener('pointerdown', () => {
        servObj.autorotate = !servObj.autorotate;
        setCameraAutorotation(servObj.autorotate);
        if (servObj.autorotate) document.querySelector('#autorotate').classList.add('active');
        else document.querySelector('#autorotate').classList.remove('active');
    });
}

function setUpCameraFromImported(importedCameraName, importedCameraTargetName) {
    const importedCamera = scene.getObjectByName(importedCameraName);
    const importedCameraTarget = scene.getObjectByName(importedCameraTargetName);

    const camera = new Camera.Perspective(container3D.canvas, importedCamera.fov, importedCamera.aspect, 0.5, 200);
    camera.name = importedCamera.name;
    camera.controls.setLookAt(
        importedCamera.position.x,
        importedCamera.position.y,
        importedCamera.position.z,
        importedCameraTarget.position.x,
        importedCameraTarget.position.y,
        importedCameraTarget.position.z
    );

    scene.setActiveCamera(camera);

    camera.controls.maxPolarAngle = Math.PI / 2 - 0.2;
    camera.controls.setBoundary(new THREE.Box3(new THREE.Vector3(-15, 0, -14), new THREE.Vector3(26, 7, 23)));

    camera.controls.draggingSmoothTime = 0.25;
    camera.controls.smoothTime = 1;
    camera.controls.minDistance = 1;
    camera.controls.maxDistance = 130;
    camera.controls.verticalDragToForward = true;

    camera.controls.autorotate = false;
    camera.controls.disableAutoRotate = true;
    let controlEnd = false;
    let sleep = false;
    camera.controls.addEventListener('controlstart', () => {
        sleep = false;
        controlEnd = false;
        camera.controls.disableAutoRotate = true;
    });
    camera.controls.addEventListener('controlend', () => {
        controlEnd = true;
        if (sleep) camera.controls.disableAutoRotate = false;
    });
    camera.controls.addEventListener('sleep', () => {
        sleep = true;
        if (controlEnd) camera.controls.disableAutoRotate = false;
    });

    servObj.perspectiveCamera = camera;

    //debug
    servObj.onClick3D.push((intersections) => {
        camera.controls.dollyTo(5, true);
        const point = intersections[0].point;
        camera.controls.setTarget(point.x, point.y, point.z, true);
    });
    setAnnHandler(camera);
}

function setupFPVCamera() {
    const fpvCamera = new Camera.Perspective(
        container3D.canvas,
        50,
        container3D.offsetWidth / container3D.offsetHeigth
    );
    fpvCamera.name = 'fpv_camera';
    scene.fpvCamera = fpvCamera;
    servObj.fpvCamera = fpvCamera;

    const EPS = 1e-5;
    fpvCamera.position.set(0, 0, EPS);
    fpvCamera.controls.setTarget(-7, 1.8, 14.66);
    fpvCamera.controls.distance = 0.01;
    fpvCamera.controls.azimuthAngle = -1.1810891801144154;
    fpvCamera.controls.polarAngle = 1.5544401102687613;

    fpvCamera.controls.minDistance = fpvCamera.controls.maxDistance = 0.01;
    fpvCamera.controls.azimuthRotateSpeed = 0.6;
    fpvCamera.controls.polarRotateSpeed = 0.6;
    fpvCamera.controls.truckSpeed = 1000;
    fpvCamera.controls.verticalDragToForward = true;
    fpvCamera.controls.setBoundary(
        new THREE.Box3(new THREE.Vector3(-13.5, 1.8, -12.5), new THREE.Vector3(25, 1.8, 17.2))
    );
    // fpvCamera.controls.colliderMeshes.push(scene.getObjectByName('collider'))

    let w = false,
        a = false,
        s = false,
        d = false,
        jumping = false,
        speedMultiplier = 1;
    fpvCamera.controls.addEventListener('update', () => {
        if (w) fpvCamera.controls.forward(0.07 * speedMultiplier, true);
        if (a) fpvCamera.controls.truck(-0.07 * speedMultiplier, 0, true);
        if (s) fpvCamera.controls.forward(-0.07 * speedMultiplier, true);
        if (d) fpvCamera.controls.truck(0.07 * speedMultiplier, 0, true);
    });
    document.addEventListener('keydown', (e) => {
        fpvCamera.controls.forward(0.01, true);
        fpvCamera.controls.forward(-0.01, true);
        switch (e.code) {
            case 'ArrowUp':
            case 'KeyW':
                w = true;
                break;
            case 'ArrowLeft':
            case 'KeyA':
                a = true;
                break;
            case 'ArrowDown':
            case 'KeyS':
                s = true;
                break;
            case 'ArrowRight':
            case 'KeyD':
                d = true;
                break;
            case 'ShiftRight':
            case 'ShiftLeft':
                speedMultiplier = 2;
                break;
            case 'Space':
                if (!jumping) {
                    jumping = true;
                    gsap.to([fpvCamera.controls._targetEnd, fpvCamera.controls._target], {
                        y: 2.5,
                        yoyo: true,
                        repeat: 1,
                        duration: 0.4,
                        onComplete: () => (jumping = false),
                    });
                }

                break;
        }
    });
    document.addEventListener('keyup', (e) => {
        switch (e.code) {
            case 'ArrowUp':
            case 'KeyW':
                w = false;
                break;
            case 'ArrowLeft':
            case 'KeyA':
                a = false;
                break;
            case 'ArrowDown':
            case 'KeyS':
                s = false;
                break;
            case 'ArrowRight':
            case 'KeyD':
                d = false;
                break;
            case 'ShiftRight':
            case 'ShiftLeft':
                speedMultiplier = 1;
                break;
        }
    });
}

function setupOrthoCamera() {
    const width = container3D.offsetWidth / 15; //window.innerWidth
    const height = container3D.offsetHeight / 15; //window.innerHeight
    const orthoCamera = new Camera.Orthographic(
        container3D.canvas,
        width / -2,
        width / 2,
        height / 2,
        height / -2,
        1,
        1000
    );
    servObj.orthoCamera = orthoCamera;
    servObj.orthoCamera.controls.azimuthRotateSpeed = 0;
    servObj.orthoCamera.controls.polarRotateSpeed = 0;
}

function setCameraAutorotation(bool) {
    scene.activeCamera.controls.autorotate = bool;
    scene.activeCamera.controls.disableAutoRotate = !bool;
}

function createLighting() {
    const lightMain = new THREE.DirectionalLight(0xffffff);
    lightMain.name = 'light_main';
    lightMain.castShadow = true;
    lightMain.shadow.needsUpdate = true;
    lightMain.shadow.camera.near = 1;
    lightMain.shadow.camera.far = 1000;
    lightMain.intensity = 2.7;
    lightMain.position.set(20, 20, 20);
    lightMain.shadow.mapSize.set(2048, 2048);
    lightMain.shadow.map?.setSize(2048, 2048);
    lightMain.shadow.normalBias = 0.1;
    lightMain.shadow.camera.top = 20;
    lightMain.shadow.camera.bottom = -20;
    lightMain.shadow.camera.left = 35;
    lightMain.shadow.camera.right = -35;
    lightMain.shadow.camera.updateProjectionMatrix();
    lightMain.shadow.intensity = 1.5;

    const lightFolder = gui.addFolder('lighting');
    lightFolder
        .addColor(lightMain, 'color')
        .name('light1Color')
        .onFinishChange((event) => console.log(event.getHexString()));
    lightFolder.add(lightMain, 'intensity').name('light1Intensity');
    lightFolder.addVector(lightMain.position, 'light1Position');
    lightFolder.add(lightMain, 'castShadow');
    lightFolder.add(lightMain.shadow, 'intensity');

    const notCastingObjs = [];
    const notRecievingObjs = ['flor_tile_curb'];
    setShadowBehaviour(scene, notCastingObjs, notRecievingObjs);

    const light2 = new THREE.DirectionalLight(0xffedce);
    light2.name = 'light_2';
    light2.intensity = 0.3;
    light2.position.set(-10, 0, -5);

    lightFolder
        .addColor(light2, 'color')
        .name('light2Color')
        .onFinishChange((event) => console.log(event.getHexString()));
    lightFolder.add(light2, 'intensity').name('light2Intensity');
    lightFolder.addVector(light2.position, 'light2Position');

    const light3 = new THREE.DirectionalLight(0xffefd7);
    light3.name = 'light_3';
    light3.intensity = 0.5;
    light3.position.set(10, 0, 5);

    lightFolder
        .addColor(light3, 'color')
        .name('light3Color')
        .onFinishChange((event) => console.log(event.getHexString()));
    lightFolder.add(light3, 'intensity').name('light3Intensity');
    lightFolder.addVector(light3.position, 'light3Position');

    const lightAmbient = new THREE.AmbientLight(0xecfcff);
    lightAmbient.name = 'light_ambient';
    lightAmbient.intensity = 0.5;

    lightFolder.add(lightAmbient, 'intensity').name('ambientIntensity');
    lightFolder
        .addColor(lightAmbient, 'color')
        .name('ambientColor')
        .onFinishChange((event) => console.log(event.getHexString()));

    lightMain.shadow.autoUpdate = false;
    lightMain.shadow.needsUpdate = true;

    servObj.lightMain = lightMain

    // lightMain.shadow.autoUpdate = false;
    lightMain.shadow.needsUpdate = true;

    scene.add(lightMain, light2, light3, lightAmbient);
    //console.log(lightMain, lightMain.shadow, light2, light3, lightAmbient);
}

export function setShadowBehaviour(group, notCastingObjs, notRecievingObjs) {
    group.traverse((obj) => {
        if (obj.isMesh) {
            obj.receiveShadow = true;
            obj.castShadow = true;
            if (notCastingObjs.includes(obj.name) || notCastingObjs.includes(obj.parent.name)) obj.castShadow = false;
            if (notRecievingObjs.includes(obj.name) || notRecievingObjs.includes(obj.parent.name))
                obj.receiveShadow = false;
        }
    });
}

function setQualityHandler() {
    const qualityParent = document.getElementById('quality');
    const qualityBtns = qualityParent.querySelectorAll('.quality');

    qualityParent.addEventListener('pointerdown', (event) => {
        qualityBtns.forEach((btn) => {
            if (btn !== event.target && event.target.id !== 'quality') {
                btn.classList.remove('active');
            }
        });

        switch (event.target.id) {
            case 'shd':
                scene.renderer.setPixelRatio(2);
                scene.getObjectByName('tree_leaf_instanced').material.alphaTest = 0.02;
                scene.getObjectByName('bush_leaf_instanced').material.alphaTest = 0.02;
                scene.getObjectByName('tree_leaf_instanced').material.needsUpdate = true;
                scene.getObjectByName('bush_leaf_instanced').material.needsUpdate = true;
                event.target.classList.add('active');
                break;
            case 'hd':
                scene.renderer.setPixelRatio(1);
                scene.getObjectByName('tree_leaf_instanced').material.alphaTest = 0.02;
                scene.getObjectByName('bush_leaf_instanced').material.alphaTest = 0.02;
                scene.getObjectByName('tree_leaf_instanced').material.needsUpdate = true;
                scene.getObjectByName('bush_leaf_instanced').material.needsUpdate = true;
                console.log(scene.getObjectByName('tree_leaf_instanced').material);
                event.target.classList.add('active');
                break;
            case 'sd':
                scene.renderer.setPixelRatio(1);
                scene.getObjectByName('tree_leaf_instanced').material.alphaTest = 0;
                scene.getObjectByName('bush_leaf_instanced').material.alphaTest = 0;
                scene.getObjectByName('tree_leaf_instanced').material.needsUpdate = true;
                scene.getObjectByName('bush_leaf_instanced').material.needsUpdate = true;
                event.target.classList.add('active');
                break;
        }
    });
}

export function setNightMode(bool) {
    if (bool) {
        scene.getObjectByName('point_lights').visible = true;
        scene.background = new THREE.Color(0x1c1c32);
        scene.backgroundIntensity = 1;
        scene.getObjectByName('light_main').color.set(0xd2d8ff);
        scene.getObjectByName('light_main').intensity = 0.6;
        scene.getObjectByName('light_main').shadow.intensity = 1;
        scene.getObjectByName('light_2').intensity = 0;
        scene.getObjectByName('light_3').intensity = 0;
        scene.getObjectByName('light_ambient').color.set(0x9aaaff);
        scene.getObjectByName('light_ambient').intensity = 0.4;
        scene.environmentIntensity = 0;

        materials.getMaterial('glass_light_pole').emissive.set(0xffa200);
        materials.getMaterial('glass_light_pole').emissiveIntensity = 2;
        materials.getMaterial('shingles').color.set(0x444444); //TMP

        if (servObj.isFPV) {
            scene.background = nightHDRI;
            scene.backgroundIntensity = 0.75;
        }
    } else {
        scene.getObjectByName('point_lights').visible = false;
        scene.background = new THREE.Color(0xffffff);
        scene.backgroundIntensity = 1;
        scene.getObjectByName('light_main').color.set(0xffffff);
        scene.getObjectByName('light_main').intensity = 2.7;
        scene.getObjectByName('light_main').shadow.intensity = 1.5;
        scene.getObjectByName('light_2').intensity = 0.3;
        scene.getObjectByName('light_3').intensity = 0.5;
        scene.getObjectByName('light_ambient').color.set(0xecfcff);
        scene.getObjectByName('light_ambient').intensity = 0.5;
        scene.environmentIntensity = 0.5;

        materials.getMaterial('glass_light_pole').emissiveIntensity = 0;
        materials.getMaterial('shingles').color.set(0x272727); //TMP

        //console.log(servObj.isFPV);

        if (servObj.isFPV) {
            scene.background = dayHDRI;
            scene.backgroundIntensity = 2;
        }
    }
}

function setAnnHandler(camera) {
    // document.addEventListener('pointerdown', (e) => {
    //     scene.getObjectByName("description_ann_wall_block").visible = false
    //     scene.getObjectByName("description_ann_fence_block").visible = false
    // })
    document.addEventListener('click', (e) => {
        if (!e.target || !e.target.offsetParent) return;
        const annName = e.target.offsetParent.id;
        console.log(annName);
        //scene.getObjectByName("description_ann_block").visible = false

        let ann;
        if (annName.includes('ann_')) ann = scene.getObjectByName(annName);
        if (!ann) return;

        // Перед запуском анимации вешаем обработчик
        function onCameraMoveEnd() {
            console.log('Камера доехала!');
            camera.controls.removeEventListener('transitionend', onCameraMoveEnd);
        }

        camera.controls.addEventListener('transitionend', onCameraMoveEnd);

        const camPos = scene.getObjectByName('cam_pos_' + annName.substring(4));
        // camera.controls.fitToSphere(new THREE.Sphere(ann.position, 2), true)
        camera.controls.setLookAt( // await 
            camPos.position.x,
            camPos.position.y,
            camPos.position.z,
            ann.position.x,
            ann.position.y,
            ann.position.z,
            true
        );

        if(annName == "ann_fence"){
            scene.getObjectByName("description_ann_wall_block").visible = false
            setTimeout(() => scene.getObjectByName("description_ann_fence_block").visible = true, 2000)
        }
        if(annName == "ann_wall"){
            scene.getObjectByName("description_ann_fence_block").visible = false
            setTimeout(() => scene.getObjectByName("description_ann_wall_block").visible = true, 2000)
        } 
        
    });
}
